import React from "react";

const Logo = props => (
  <svg width={props.width || 62} height={props.width || 23} viewBox="0 0 124 46" {...props}>
    <path
      d="M74.707 0h42.728a5.623 5.623 0 0 1 4.87 8.435L102.24 43.188a5.623 5.623 0 0 1-9.739 0l-8.181-14.17a5.623 5.623 0 0 0-9.74 0l-8.18 14.17a5.623 5.623 0 0 1-9.74 0l-3.444-5.965a5.623 5.623 0 0 1 0-5.623L69.837 2.812A5.623 5.623 0 0 1 74.707 0zM20.82 43.188L.754 8.435A5.623 5.623 0 0 1 5.624 0h40.13a5.623 5.623 0 0 1 4.869 8.435L30.558 43.188a5.623 5.623 0 0 1-9.739 0z"
      fillRule="evenodd"
    />
  </svg>
);

export default Logo;
